import React, { Component } from 'react';
import { initConfigurator } from '../modules/config';

export default class ConfigContainer extends Component {
  componentDidMount() {
    const {
      api,
      configId,
      form,
      configuration,
      callback,
      setAppState,
    } = this.props;
    initConfigurator(api, configId, {
      elOrElId: 'config-embed',
      configuration,
      form,
    }).then(() => {
      if (callback) callback(api);
    });
    api.on('configurationChange', e => {
      const { size } = this.props;
      let attr = null;
      let value = null;
      if (e && e.length > 0) {
        attr = e[0].name;
        value = e[1];

        if (attr === 'Outriggers & Infills- Closed Frame') {
          const newSize = value.trim().charAt(0) * 1;

          if (newSize !== size) {
            if (newSize === 8) {
              api.configuration
                .setConfiguration({
                  '6" Crowns ': 'None',
                  '6" Profiles ': 'None',
                })
                .then(() => {
                  api.configuration.setAttributeVisibility('6" Crowns ', false);
                });

              // api.configuration.setConfiguration({});
            } else {
              api.configuration
                .setConfiguration({
                  '8" Crowns ': 'None',
                  '8" Profiles ': 'None',
                })
                .then(() => {
                  api.configuration.setAttributeVisibility('8" Crowns ', false);
                });

              // api.configuration.setConfiguration({ });
            }
            setAppState({ size: newSize });
          }
        }
        callback(api, attr, value);
      }

      if (callback) callback(api, attr, value);
    });

    document.addEventListener('click', function() {
      if (api) {
        const config = api.configuration.getConfiguration();
        if (
          config['Outriggers & Infills- Open Frame'] ||
          config['Outriggers & Infills- Closed Frame']
        ) {
          const value = config['Outriggers & Infills- Open Frame']
            ? config['Outriggers & Infills- Open Frame']
            : config['Outriggers & Infills- Closed Frame'];
          const name = config['Outriggers & Infills- Open Frame']
            ? 'Outriggers & Infills- Open Frame'
            : 'Outriggers & Infills- Closed Frame';
          if (callback) callback(api, name, value);
        }
      }
    });
  }

  divClick = () => {
    const { api, callback } = this.props;
    callback(api);
  };
  componentWillReceiveProps(newProps) {
    const { api, configId, form, configuration, callback } = this.props;
    if (configId !== newProps.configId) {
      initConfigurator(api, configId, {});
      initConfigurator(api, configId, {
        elOrElId: 'config-embed',
        configuration,
        form,
      }).then(() => {
        if (callback) callback();
      });
    }
  }
  render() {
    return <div onClick={this.divClick} id="config-embed" />;
  }
}



// WEBPACK FOOTER //
// ./src/component/ConfigContainer.js